import { get, patch } from "./base";
import store from "../store";
import * as actions from "../store/actions/notifications";
import url from "./url";
import queries from "./queries";

const { dispatch } = store;

export default class notificationAPI {
  static async get() {
    try {
      dispatch(actions.getNotifications());
      const query = url(queries.notifications);
      const response = await get(query);
      return dispatch(actions.getNotificationsSuccess(response));
    } catch (error) {
      const err = (error.response && error.response.data) || error;
      return dispatch(actions.getNotificationsFailed(err));
    }
  }

  static async setViewed({ id = "" } = {}) {
    try {
      dispatch(actions.setNotificationViewed());
      const query = url(queries.notifications, id);
      await patch(query, { is_read: true });

      return dispatch(actions.setNotificationViewedSuccess(id));
    } catch (error) {
      const err = (error.response && error.response.data) || error;
      return dispatch(actions.setNotificationViewedFailed(err));
    }
  }
}
